import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoAsentamiento, TipoAsentamientoProps } from '../../interfaces/catalogos/TipoAsentamientoInterface';

export const ObtenerTiposAsentamientos = () => {

    return new Promise<TipoAsentamientoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoAsentamiento/ObtenerTipoAsentamientos', token)
            .then( ({ data } : { data : TipoAsentamientoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const TipoAsentamiento = () => {

    return new Promise<TipoAsentamientoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoAsentamiento/', token)
            .then( ({ data } : { data : TipoAsentamientoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoAsentamiento = ( params: TipoAsentamientoProps ) => {

    return new Promise<TipoAsentamientoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoAsentamiento/Actualizar', params, token)
            .then( ({ data } : { data : TipoAsentamientoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoAsentamiento } );
            });

        }

    });

}

export const AgregarTipoAsentamiento = ( params: TipoAsentamientoProps ) => {

    return new Promise<TipoAsentamientoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoAsentamiento/Agregar', params, token)
            .then( ({ data } : { data : TipoAsentamientoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoAsentamiento } );
            });

        }

    });

}
